import React from "react"

import { useForm } from "react-hook-form"
import { Link, useNavigate } from "react-router-dom"

import { FRONT_VALIDATION_CONFIG } from "@front-shared/config/validation.config"
import { ButtonElement } from "@front-shared/elements/button.element"
import { InputElement } from "@front-shared/elements/input.element"
import { PageHelmetElement } from "@front-shared/elements/pageHelmet.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"
import { useScrollFix } from "@front-shared/hooks/scrollFix.hook"

import { GENERAL_CONFIG } from "../../config/general.config"
import { ROUTES_CONFIG } from "../../config/routes.config"
import { useAppDispatch } from "../../store/appDispatch.hook"
import { useAppSelector } from "../../store/selectors/app.selector"
import { authSelector } from "../../store/selectors/auth.selector"
import { authForgotPassword } from "../../store/thunks/auth.thunks"

import arrowRightIcon from "@front-shared/assets/images/icons/arrow-right2.svg"
import mailIcon from "@front-shared/assets/images/icons/mail-dark.svg"
import mainImage from "@front-shared/assets/images/shapes/reset-password.svg"

export const RestoreComponent: React.FunctionComponent = () => {
    useScrollFix()

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm()

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const authState = useAppSelector(authSelector)

    const onPasswordRestore = (data: any) => {
        dispatch(
            authForgotPassword({
                payload: data.email,
                navigate,
            }),
        )
    }

    return (
        <div className="md:px-[16px]">
            <PageHelmetElement
                title="Reset Password"
                defaultPageTitle={GENERAL_CONFIG.defaultPageTitle}
            />

            <img
                src={mainImage}
                alt="Nirvana"
                title="Nirvana"
                className="mx-auto sm:w-[150px]"
            />

            <PrimaryText centered className="mt-[32px]" typography="h1">
                Reset password
            </PrimaryText>

            <PrimaryText centered className="mt-[32px]" typography="subtitle">
                We will send you a verification code, <br /> which you will need
                to reset your password.
            </PrimaryText>

            <form onSubmit={handleSubmit(onPasswordRestore)} noValidate={true}>
                <InputElement
                    className="mt-[44px]"
                    name="email"
                    label="Email address"
                    reactHookControl={control}
                    reactHookErrors={errors}
                    reactHookValidations={{
                        required: FRONT_VALIDATION_CONFIG.required,
                        pattern: FRONT_VALIDATION_CONFIG.email,
                        maxLength: FRONT_VALIDATION_CONFIG.maxLength,
                    }}
                    inputSuffix={
                        <img
                            src={mailIcon}
                            alt="Email address"
                            title="Email address"
                            className="ml-[8px]"
                        />
                    }
                />

                <div className="mt-[32px] flex items-center">
                    <div className="flex-1 mr-[24px]">
                        <Link to={ROUTES_CONFIG.loginUrl}>Cancel</Link>
                    </div>

                    <ButtonElement
                        label="Reset"
                        type="primary"
                        htmlType="submit"
                        size="large"
                        icon={arrowRightIcon}
                        isRightIcon
                        isLoading={authState.isLoading}
                    />
                </div>
            </form>
        </div>
    )
}
